
$(function () {
  var removeClass = true;

  $(".search-pop").on("click", function (e) {
    e.preventDefault();
    $(".search-popup").addClass("active-search");
  });
  $(".search-close").on("click", function (e) {
    e.preventDefault();
    $(".search-popup").removeClass("active-search");
  });

  $(".login_close_u, .login-close-icon").click(function () {
    $(".login-popup").toggleClass("login-active");
    removeClass = false;
  });
  // when clicking the div : never remove the class
  $(".live-chat-popup, .login-popup").click(function () {
    removeClass = false;
  });
  // when click event reaches "html" : remove class if needed, and reset flag
  $("html").click(function () {
    if (removeClass) {
      $(".live-chat-popup").removeClass("live-active");
      $(".login-popup").removeClass("login-active");
    }
    removeClass = true;
  });

  if ($("body").data("ajaxcart")) {
    $("body").on("click", ".mini-cart-btn", function (e) {
      e.preventDefault();

      var dynamicCheckout = $('.dynamic-checkout__content')[0];
      $('.checkout-pay').append(dynamicCheckout)

      $(".mini-cart-wrapper, body").addClass("active-cart");
    });
    $("body").on("click", ".close-cart, .overlay", function (e) {
      e.preventDefault();
      $(".mini-cart-wrapper, body").removeClass("active-cart");
    });
  } else {
    $("body").on("click", ".mini-cart-btn", function (e) {
      e.preventDefault();
      window.location.href = window.Shopify.routes.root+"cart";
    });
  }

});
